import { computed, ref, useFetch } from '@nuxtjs/composition-api'

import * as endpoints from '~/api/endpoints'

import ApiErrorMessage from '~/components/api-error-message/api-error-message.vue'
import BuyProduct from '~/components/create-order/buy/buy-product.vue'
import WDialogLayout from '~/components/global/w-dialog/w-dialog-layout'

import { useApiFetch } from '~/composables/useApiFetch'

import { gettext } from '~/i18n/catalog'
import { getProductName } from '~/utils/product-info'
import { types as itemTypes } from '~/utils/product-item-type'


export default {
  __name: 'buy-order-dialog',
  props: {
  age: {
    type: Number,
    default: undefined,
  },
  batchName: {
    type: String,
    default: undefined,
  },
  brandName: {
    type: String,
    default: undefined,
  },
  displayName: {
    type: String,
    default: undefined,
  },
  isAnchored: {
    type: Boolean,
    default: false,
  },
  itemId: {
    type: [Number, String],
    required: true,
  },
  itemType: {
    type: String,
    required: true,
    validator: (v) => Object.values(itemTypes).includes(v),
  },
  name: {
    type: String,
    required: true,
  },
  price: {
    type: Number,
    default: undefined,
  },
},
  setup(__props) {

const props = __props;



const marketAvailability = ref({
  quantityAvailableOnMarket: 0,
  priceFrom: null,
})

const orders = ref(null)
const isBidForm = ref(false)

const title = computed(() => {
  return isBidForm.value
    ? gettext('Place buy order')
    : gettext('Add to Portfolio')
})

const productName = computed(() =>
  getProductName(props, {
    includeBatchName: false,
  }),
)

const loadBuyOrderDefaults = async () =>
  await useApiFetch(`${endpoints.getBuyOrderDefaults}?itemId=${props.itemId}`)

const loadOrders = async () =>
  await useApiFetch(
    `${endpoints.getProductOrders(props.itemId)}?maxCount=99999`,
  )

const { fetchState } = useFetch(async () => {
  const [orderData, { marketAvailability: marketAvailabilityData }] =
    await Promise.all([loadOrders(), loadBuyOrderDefaults()])

  orders.value = orderData
  if (marketAvailabilityData) {
    marketAvailability.value = marketAvailabilityData
  }
})

const setIsBidForm = (value) => {
  isBidForm.value = value
}

return { __sfc: true,props, marketAvailability, orders, isBidForm, title, productName, loadBuyOrderDefaults, loadOrders, fetchState, setIsBidForm, ApiErrorMessage, BuyProduct, WDialogLayout }
}

}